import 'jquery-cookie';

export default function getTreatment(name) {
  if (!SS.serverBootstrap.flags) {
    return false;
  }
  return SS.serverBootstrap.flags[name];
}

export function getAllFlagTreatments() {
  if (!SS.serverBootstrap.flags) {
    return {};
  }

  return SS.serverBootstrap.flags;
}

// gr_mui_auth
export function shouldMUIAuth() {
  return getTreatment('gr_mui_auth') == 'on';
}

// pl_a0_web
export function shouldShowAuth0() {
  return getTreatment('pl_a0_web') === 'on';
}

// pl_a0_popup
export function shouldRenderAuth0Popup() {
  return getTreatment('pl_a0_popup') === 'on';
}

export function deferredVideoPlayerTestIsActive() {
  return getTreatment('lx_growth_vpdl') === 'on';
}

export function shouldRenderTeacherReferralLocd() {
  return getTreatment('gr_tr_locd') === 'on';
}

export function shouldShowUpdatedCopyOnPublishClassDialog() {
  return getTreatment('i18n_cmd_submit') === 'on';
}

export function shouldRenderLanguageDropdownFirst() {
  return getTreatment('i18n_cmd_ccls') === 'on';
}
